let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("682Fg")).then(() => parcelRequire('feZZH'));